import { MensajesGenericos_ES } from "./Genericos/DiccionarioMensajesGenericos_ES";
import { DiccionarioAcademico_ES } from "./DiccionariosAreas/DiccionarioAcademico_ES";
import { DiccionarioSeguridad_ES } from "./DiccionariosAreas/DiccionarioSeguridad_ES";
import { DiccionarioLogin_ES } from "./DiccionariosAreas/DiccionarioLogin_ES";
import { DiccionarioCajas_ES } from "./DiccionariosAreas/DiccionarioCajas_ES";

const DiccionarioInterno = [
  {
    codigo: "ErrorValidUUID",
    mensaje: "Token de validación no valido",
  },
  {
    codigo: "ErrorValidFormatUUID",
    mensaje: "Formato del token de validación no valido",
  },
  {
    codigo: "ErrorRequiredEmail",
    mensaje:
      "No tiene un correo asociado a su cuenta de usuario. Contactar con la administración.",
  },
  {
    codigo: "SussesEmailSend",
    mensaje:
      "Código de verificación enviado satisfactoriamente a su cuenta de correo.",
  },
  {
    codigo: "ErrorExistsClient",
    mensaje: "Ya existe otro estudiante con esa identificación.",
  },
  {
    codigo: "DuplicateCustomerEmailNI",
    mensaje:
      "El correo electrónico ingresado no se encuentra disponible. Contactar con la administración.",
  },
  {
    codigo: "NoFileRules",
    mensaje: "El archivo no cumple con las reglas de configuracion.",
  },
  {
    codigo: "InvalidEmailFormat",
    mensaje: "El correo electrónico ingresado no es válido.",
  },
  {
    codigo: "ErrorValidatingEmail",
    mensaje:
      "Ocurrió un error durante la validación del correo. Intente nuevamente.",
  },
  {
    codigo: "VerificationCodeSent",
    mensaje: "Código de verificación enviado a tu correo electrónico.",
  },
  {
    codigo: "VerificationCodeInvalid",
    mensaje: "Código de verificación inválido.",
  },
  {
    codigo: "VerificationCodeExpired",
    mensaje: "El código ha expirado. Solicita uno nuevo.",
  },
  {
    codigo: "VerificationCodeSuccess",
    mensaje: "Email verificado correctamente.",
  },
  {
    codigo: "CancelVerificationCodeSuccess",
    mensaje: "El código de verificación ha sido cancelado",
  },
  {
    codigo: "CancelVerificationCodeError",
    mensaje: "Error cancelando el código de verificacion. Intente nuevamente",
  },
  {
    codigo: "VerificationCodeAlreadyUsed",
    mensaje: "Este código ya fue utilizado.",
  },
  {
    codigo: "VerificationCodeError",
    mensaje: "Error al verificar el código. Inténtalo nuevamente.",
  },
  {
    codigo: "SuccessRegister",
    mensaje: "Registro exitoso.",
  },
  {
    codigo: "ErrorValidatingIdentification",
    mensaje:
      "Ocurrió un error al validar la identificación. Inténtalo nuevamente.",
  },
  {
    codigo: "ErrorProviderNotConfiguredOrInactive",
    mensaje:
      "El proveedor de servicios no está configurado o se encuentra inactivo.",
  },
  {
    codigo: "ValidationProviderError",
    mensaje:
      "Error de validación del proveedor de servicios. Inténtalo nuevamente.",
  },
  {
    codigo: "ErrorIdentificationAlreadyExists",
    mensaje:
      "La identificación ingresada ya existe. Por favor, ingresa una diferente.",
  },
  {
    codigo: "ErrorIdentificationNotFound",
    mensaje: "No se encontró un registro con la identificación ingresada.",
  },
  {
    codigo: "ErrorCUIIsMinor",
    mensaje:
      "La identificación está asociada a un menor de edad, complete los datos de forma manual por favor.",
  },
];

export const DiccionarioMensajes_ES = [
  ...DiccionarioInterno,
  ...MensajesGenericos_ES,
  ...DiccionarioLogin_ES,
  ...DiccionarioAcademico_ES,
  ...DiccionarioSeguridad_ES,
  ...DiccionarioCajas_ES,
];
